import { Card } from "@/components/ui/card";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

const data = [
  { name: "Jan", entrada: 40, saida: 24 },
  { name: "Fev", entrada: 30, saida: 13 },
  { name: "Mar", entrada: 20, saida: 38 },
  { name: "Abr", entrada: 27, saida: 39 },
  { name: "Mai", entrada: 18, saida: 48 },
  { name: "Jun", entrada: 23, saida: 38 },
];

export function StockMovementChart() {
  return (
    <Card className="p-6">
      <h3 className="text-lg font-semibold mb-4">Movimentação de Estoque</h3>
      <div className="h-[300px]">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Bar dataKey="entrada" fill="#0073B7" name="Entradas" />
            <Bar dataKey="saida" fill="#E60026" name="Saídas" />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </Card>
  );
}